import { render, staticRenderFns } from "./SaasTransactionDetails.vue?vue&type=template&id=49b5fbfb&"
import script from "./SaasTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./SaasTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports